module.exports = __webpack_public_path__ + "img/payment-neteller.bb39b53a.svg";